import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { getChargesByType } from '@components/ProductOffers/modals/ShoppingCartDrawer/utils/pricingSummary.utils';
import ChargeSection from '@components/ProductOffers/modals/ShoppingCartDrawer/PricingSummary/ChargeSection';
import type { PricingSummaryProps } from '@components/ProductOffers/modals/ShoppingCartDrawer/PricingSummary/PricingSummary.types';

export const PricingSummary = ({ cart, plansByCategory }: PricingSummaryProps) => {
  const monthly = getChargesByType(cart, 'recurring', plansByCategory);
  const oneTime = getChargesByType(cart, 'oneTime', plansByCategory);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <ChargeSection
        title="Monthly Charges"
        description="These are the charges that will be applied to your account every billing cycle."
        breakdown={monthly}
      />

      <Divider variant="cartSection" />

      <ChargeSection
        title="One-Time Charges"
        description="These charges will be applied only once upon completing this purchase."
        breakdown={oneTime}
      />
    </Box>
  );
};

export { fmt, getChargesByType } from '../utils/pricingSummary.utils';
export type { ChargeBreakdown } from './PricingSummary.types';
